<template>
  <div class="navbar-box">
    <div class="navbar max_width">
      <div class="logo" @click="toHome">
        <img class="image" src="@/assets/mobile/logo_global.jpg" alt="" />
      </div>
      <div class="menu">
        <el-menu router :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="/home" class="home" @mouseenter.native="close">首页</el-menu-item>
          <el-submenu index="/mercury-project" @mouseenter.native="close">
            <template slot="title">
              <svgicon icon="rocket" width="20" height="20" :color="activeIndex.includes('mercury') ? '#377CFF' : '#6EDFBB'"></svgicon>
              水星计划
            </template>
            <el-menu-item @click="toPlan">关于水星计划</el-menu-item>
            <el-menu-item @click="toService">开发服务</el-menu-item>
          </el-submenu>
          <!-- <el-submenu index="/mercury-project" @mouseenter.native="showList = false">
            <template slot="title">
              :color="activeIndex.includes('mercury') ? '#377CFF' : ''"
              <svgicon icon="rocket" width="20" height="20"></svgicon>
              水星计划
            </template>
            <el-menu-item index="/mercury-project/about">关于水星计划</el-menu-item>
            <el-menu-item index="/mercury-project/service">开发服务</el-menu-item>
          </el-submenu> -->
          <el-menu-item index="/bioengineering-technology" @mouseenter.native="show" disabled>
            生物制造工艺
          </el-menu-item>
          <el-menu-item index="/molecular-diagnosis" @mouseenter.native="showMoles" disabled>实验与诊断智能</el-menu-item>
          <!-- <el-menu-item :index="activeIndex" @mouseenter.native="show">
            生物工程工艺
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-menu-item>
          <el-menu-item :index="activeIndex" @mouseenter.native="show">
            分子诊断
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-menu-item> -->
          <el-submenu index="/about" @mouseenter.native="close">
            <template slot="title">关于我们</template>
            <el-menu-item index="/about/about-introduce">公司介绍</el-menu-item>
            <!-- <el-menu-item index="/about/about-report">媒体报道</el-menu-item> -->
            <el-menu-item index="/about/about-connect">联系我们</el-menu-item>
            <el-menu-item index="/about/about-join">加入合木</el-menu-item>
          </el-submenu>
        </el-menu>
        <div class="contact" @mouseenter="showList = false">
          <CommonDialog :dialogFormVisible.sync="Visible" />
          <el-button type="primary" @click="dialogClick" class="btn_style">联系销售</el-button>
        </div>
      </div>
    </div>
    <transition name="list">
      <div class="list" v-if="showList" @mouseenter="show" @mouseleave="hide">
        <div class="goods_box">
          <div :class="{ goods_item: true, mb40: index <= 5 }" v-for="(item, index) in goodsList" :key="index" @click="toList(item)">
            <div class="picture">
              <img :src="require(`@/assets/img/bigengineering/${item.img}`)" alt="" />
            </div>
            <div class="tag">
              <div class="text">{{ item.tag }}</div>
            </div>
            <div class="text1">{{ item.text1 }}</div>
            <div class="text1">{{ item.text2 }}</div>
          </div>
        </div>
      </div>
      <div class="list" v-if="showMole" @mouseenter="showMoles" @mouseleave="hideMoles">
        <div class="goods_box">
          <div :class="{ goods_item: true, mb40: index <= 3 }" v-for="(item, index) in moleList" :key="index" @click="toMoleList(item)">
            <div class="picture">
              <img :src="require(`@/assets/img/bigengineering/${item.img}`)" alt="" />
            </div>
            <div class="tag">
              <div class="text">{{ item.tag }}</div>
            </div>
            <div class="text1">{{ item.text1 }}</div>
            <div class="text1">{{ item.text2 }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import '@/compiled-icons/rocket';
import '@/compiled-icons/phone';
import '@/compiled-icons/clock';
import '@/compiled-icons/email';

export default {
  name: 'index',
  components: {
    CommonDialog: () => import('../dialog/index.vue')
  },
  data() {
    return {
      Visible: false,
      activeIndex: '/home',
      showList: false,
      showMole: false,
      moleList: [
        { img: 'AceLine.jpg', tag: '流水线', text1: 'ACE Line', text2: '血液样本前处理' },
        { img: 'Lib-Master.jpg', tag: '工作站', text1: 'Lib Master', text2: '测序文库构建' },
        { img: 'Gemini.jpg', tag: '工作站', text1: 'Gemini', text2: '生信分析一体机' }
      ],
      goodsList: [
        { img: 'COMBO-E1.jpg', tag: '工作站', text1: 'Combo-E', text2: '酶试剂分装' },
        { img: 'COMBO-Q.jpg', tag: '工作站', text1: 'Combo-Q', text2: '螺旋管试剂分装系统' },
        { img: 'COMBO-G.jpg', tag: '工作站', text1: 'Combo-G', text2: '通用螺旋管试剂分装系统' },
        { img: 'Combo-M.jpg', tag: '工作站', text1: 'Combo-M', text2: '超高速核酸提取预分装试剂生产线' },
        { img: 'Flex-SC.jpg', tag: '工作站', text1: 'Flex-SC', text2: 'SOC生物芯片组装系统' },
        { img: 'Flex-CG.jpg', tag: '流水线', text1: 'Flex-CG', text2: '抗原检测卡盒组装机' }
      ]
    };
  },
  methods: {
    close() {
      this.showMole = false;
      this.showList = false;
    },
    dialogClick() {
      this.Visible = true;
    },
    show() {
      this.showList = true;
    },
    showMoles() {
      this.showMole = true;
      this.showList = false;
    },
    hide() {
      this.showList = false;
    },
    hideMoles() {
      this.showMole = false;
      this.showList = false;
    },
    handleSelect(key) {
      this.activeIndex = key;
    },
    toHome() {
      this.$router.push('/home');
      this.activeIndex = '/home';
    },
    toList(item) {
      this.$router.push({ path: '/bioengineering-technology', query: { name: item.text1, parent: '生物制造工艺' } });
      this.activeIndex = '/bioengineering-technology';
      this.hide();
    },
    toMoleList(item) {
      this.$router.push({ path: '/molecular-diagnosis', query: { name: item.text1, parent: '实验与诊断智能' } });
      this.activeIndex = '/molecular-diagnosis';
      this.hideMoles();
    },
    toPlan() {
      this.$router.push({ path: '/mercury-project/about' });
      this.activeIndex = '/mercury-project';
    },
    toService() {
      this.$router.push({ path: '/mercury-project/service' });
      this.activeIndex = '/mercury-project';
    }
  },
  mounted() {
    this.activeIndex = window.location.pathname;
  }
};
</script>

<style lang="less" scoped>
@maxWidth: max_width;
@media screen and (max-width: 1440px) {
  .@{maxWidth} {
    max-width: 1200px !important;
  }
}
/deep/ .el-menu-item {
  color: #5b6881;
}
/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #5b6881;
}
/deep/.el-menu--horizontal > .el-menu-item.is-active {
  color: #009aef;
}
/deep/.el-menu--horizontal > .el-menu-item.is-active :hover {
  color: #303133;
}
/deep/.el-submenu.is-active {
  .el-submenu__title {
    color: #009aef;
  }
}
/deep/.el-menu-item.is-disabled {
  opacity: 1;
  cursor: default;
  background: 0 0 !important;
}
.list-enter-active {
  transition: opacity 0.5s;
}
.list-enter {
  opacity: 0;
}
.list-leave-active {
  transition: opacity 0.5s;
}
.list-leave-to {
  opacity: 0;
}
.hide {
  display: none !important;
}

.navbar-box {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: #ffffff;
  border-bottom: 1px solid rgba(91, 104, 129, 0.2);

  .navbar {
    max-width: 1360px;
    height: 60px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    z-index: 1000;
    justify-content: space-between;

    .logo {
      cursor: pointer;
      display: flex;
      align-items: center;

      .image {
        height: 40px;
        width: 115px;
      }
    }

    .menu {
      display: flex;
      height: 100%;
      z-index: 2000;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 3px;

      .home {
        font-size: 16px;
      }

      .contact {
        display: inline-block;
        .mode {
          margin-right: 10px;
        }
      }
    }
  }

  .btn_style {
    min-height: 36px;
    padding: 2px 10px;
    white-space: nowrap;
    border-radius: 4px;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    color: #ffffff;
    width: 88px;
    height: 36px;
    background: #009aef;
    border-radius: 4px;
    border: none;
  }

  .list {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    padding: 24px 0px;
    position: fixed;
    width: 100%;
    left: 0px;
    padding: 24px 0;
    top: 60px;
    background: #ffffff;
    z-index: 99999;

    .goods_box {
      display: flex;
      justify-content: space-between;
      gap: 40px;

      .goods_item {
        position: relative;
        width: 120px;
        cursor: pointer;
        .picture {
          width: 120px;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid rgba(130, 147, 178, 0.2);
          border-radius: 4px;
          overflow: hidden;
          margin-bottom: 8px;
          img {
            border-radius: 8px;
            margin-top: 32px;
          }
        }

        .tag {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          width: 58px;
          height: 28px;
          left: 0px;
          top: 0px;
          background: linear-gradient(90deg, rgba(0, 154, 239, 0.2) 0%, rgba(0, 154, 239, 0) 100%);
          border-radius: 4px 0px 0px 0px;

          .text {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            color: #009aef;
          }
        }

        .text1 {
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          text-align: center;
          color: #112448;
          margin-bottom: 8px;
        }

        .text2 {
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          text-align: center;
          color: #112448;
        }

        .content {
          width: 570px;
          height: 40px;
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #112448;
        }
      }
    }
  }
}

.el-menu.el-menu--horizontal,
.el-menu--horizontal > .el-menu-item.is-active {
  border: none;
  // font-size: 16px;
}

/deep/ .el-submenu__title {
  border: none !important;
}

.dialog-footer {
  margin: bottom 40px;
  .btn_dialog {
    flex-direction: row;
    padding: 8px 16px;
    gap: 49px;
    width: 88px;
    height: 36px;
    background: #009aef;
    border-radius: 4px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pc/components/navbar.vue